module.exports = __webpack_public_path__ + "img/1.8ccd95d7.png";